import { useState } from 'react';
import { useAuth } from '@/core/auth/AuthContext';
import { StandardListLayout } from '@/shared/layout/StandardListLayout';
import { useUtilitySystems } from '../hooks/useUtility';
import { UtilityKpiGrid } from './components/UtilityKpiGrid';
import { UtilityToolbar } from './components/UtilityToolbar';
import { UtilityTable } from './components/UtilityTable';
import { UtilityMobileCards } from './components/UtilityMobileCards';

export function UtilitySystemListPage() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';

  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [page, setPage] = useState(1);
  const pageSize = 10;

  const { systems, stats, isLoading } = useUtilitySystems(companyId);

  const filtered = systems.filter(s => {
    const matchSearch = !search || s.system_name.toLowerCase().includes(search.toLowerCase()) || s.system_code.toLowerCase().includes(search.toLowerCase());
    const matchStatus = statusFilter === 'all' || s.status_code === statusFilter;
    return matchSearch && matchStatus;
  });
  const paged = filtered.slice((page - 1) * pageSize, page * pageSize);

  return (
    <StandardListLayout
      title="Tiện ích (Utility)"
      description="Quản lý hệ thống tiện ích phục vụ thi công và bảo dưỡng"
      isLoading={false}
      viewMode="table"
      kpiSection={<UtilityKpiGrid stats={stats} isLoading={isLoading} />}
      toolbarSection={
        <UtilityToolbar
          search={search}
          onSearchChange={(val) => { setSearch(val); setPage(1); }}
          statusFilter={statusFilter}
          onStatusChange={(status) => { setStatusFilter(status); setPage(1); }}
        />
      }
      tableSection={
        <UtilityTable
          items={paged}
          total={filtered.length}
          page={page}
          pageSize={pageSize}
          isLoading={isLoading}
          onPageChange={setPage}
          onPageSizeChange={() => {}}
        />
      }
      cardSection={
        <UtilityMobileCards
          items={paged}
          total={filtered.length}
          page={page}
          pageSize={pageSize}
          isLoading={isLoading}
          onPageChange={setPage}
          onPageSizeChange={() => {}}
        />
      }
    />
  );
}

export default UtilitySystemListPage;
